import { Component,Input, ViewChild, OnChanges } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators'; 
import { AuthenticationService } from 'src/app/_services'; 
import {environment} from "../../../environments/environment";
import {HttpClient, HttpEvent, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core'; 
import { MatSidenav } from '@angular/material';
import { TicketService } from '../../_services';
import { first } from 'rxjs/operators';
import { CanalService } from 'src/app/_services/canal.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
@Injectable({ providedIn: 'root' })
export class SidenavComponent implements OnChanges {
  backendUrl: string = environment.apiUrl;
  url_final: string;
  current_user: any
   

	@ViewChild('drawer', {static: true}) public sidenav: MatSidenav;
	@Input()
	openNav: boolean;
  total_notificaciones: number = 0;
  total_productos_sin_match: number = 0;
  activado = false;
  hay_datos = false;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    private canalService: CanalService,
    private translate : TranslateService ,
    private ticketService: TicketService
    ) {
      window.setInterval(() => {
        this.obtenerTotalNotificaciones();
      }, 60 * 1000);
      translate.setDefaultLang(localStorage.getItem('idioma'));
    }
   


  ngOnChanges(): void {
    this.sidenav.toggle();
  }
  
  ngOnInit() {
    this.asignarDatos(); 
    this.activado = false;
    this.obtenerTotalNotificaciones();
    this.obtenerProductosSinMatch();
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }

  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

   

  ngDoCheck(){

  }

  async obtenerTotalNotificaciones(){
    this.activado = false;
    this.ticketService.consultarTotalNotificaciones()
      .pipe(first())
      .subscribe(
        data => {
          if(data["body"]["total"] > 0){
            this.total_notificaciones = data["body"]["total"];
            this.hay_datos = true;
          }else{
            this.total_notificaciones = 0;
            this.hay_datos = false;
          }
        },
        error => {
        }
      );
  }

  obtenerProductosSinMatch(){
    this.canalService.obtenerProductosSinMatch()
    .pipe(first())
    .subscribe(
      data => {
          if(data.status == 200){
            this.total_productos_sin_match = data["body"]["total"];
          }else{
            this.total_productos_sin_match = 0;
          }
        },
      error => {
    });
  }

}

